// import 'core-js/stable';
// import 'regenerator-runtime/runtime';

import cookie from 'js-cookie';
import Events from 'tf-events-1';

const events = Events();

export const get = () => {
	let participantsAges = cookie.get('participants-ages') || JSON.stringify(_participantsAges);
	try {
		participantsAges = JSON.parse(participantsAges);
		participantsAges = participantsAges.map(age => isNaN(parseInt(age)) ? adultAge : age);
	} catch(e){
		participantsAges = _participantsAges;
	}
	return participantsAges;
}

let adultAge = 18;
export const setAdultAge = _adultAge => {
	adultAge = _adultAge;
}
export const getAdultAge = () => {
	return adultAge;
}

let _participantsAges = [adultAge, adultAge];
export const setDefault = participantsAges => {
	_participantsAges = participantsAges;
}
export const getDefault = () => _participantsAges;

export const set = participantsAges => {
	cookie.set('participants-ages', JSON.stringify(participantsAges), {expires: 60});
	events.fire('change', participantsAges);
}

export const on = events.on;
export const once = events.once;
export const off = events.off;
export const fire = events.fire;